export default function scrollToTarget(target, defaultOffset, headerOffset = false) {
    const bodyTopPosition = document.body.getBoundingClientRect().top;
    const elementPosition = target.getBoundingClientRect().top - bodyTopPosition;
    let offset = defaultOffset;
    if (headerOffset) {
        const header = document.querySelector('[data-header-topbar]');
        if (header !== null) {
            offset += header.clientHeight;
        }
    }
    const offsetPosition = elementPosition - offset;
    window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
    });
}
